import { z } from 'zod';

export const captainChallengeSchema = z.object({
	comment: z
		.string()
		.min(5, 'Challenge description must be at least 5 characters long')
		.max(500, 'Challenge description cannot exceed 500 characters')
});

export type CaptainChallengeData = z.infer<typeof captainChallengeSchema>;
